import { Link } from "gatsby"
import React from "react"
import OurPartners from "../../images/our-partners-img.svg"

const Hero = () => {
  return (
    <section className="container mx-auto md:mt-20 px-6">
      <div className="flex flex-col-reverse md:flex-row items-center">
        <div className="flex-1 md:w-1/2">
          <h1 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
            <span className="text-secondary font-bold block">Became</span> our
            partners
          </h1>
          <h3 className="text-3xl pb-4">We love teamwork!</h3>
          <p className="pb-8">
            Join our community and achieve great results with us.
          </p>
          <Link
            to="/contact"
            className="mx-auto lg:mr-5 lg:mx-0 my-8 hover:text-white hover:bg-secondary hover:text-variant btn"
          >
            Join now
          </Link>
        </div>
        <div className="flex-1 my-8 md:my-0 w-full md:w-1/2">
          <img src={OurPartners} alt="Why we are here?" className="mx-auto" />
        </div>
      </div>
    </section>
  )
}

export default Hero
